import {Component, OnInit} from '@angular/core';
import {AbastecimentosViewModel} from "../model/abastecimentos-view-model";
import {Router} from "@angular/router";
import {LoginModel} from "../../model/login.model";
import {SubfrotaService} from "../subfrota.service";
import {AuthenticationService} from "../../services/authentication.service";
import {SnackBarService} from "../../services/snack-bar-service.service";
import {NomeCombustivel} from "../../precos-combustiveis/model/AlteracaoCombustivel";
import {FormBuilder} from "@angular/forms";
import {AbastecimentoPutModel} from "../model/abastecimento-put-model";
import {LocalStorageService} from 'src/app/services/localstorage.service';
import {Contato} from "../model/contato";

@Component({
  selector: 'app-sub-frota-salvar-abastecimento',
  templateUrl: './sub-frota-salvar-abastecimento.component.html',
  styleUrls: ['./sub-frota-salvar-abastecimento.component.scss']
})
export class SubFrotaSalvarAbastecimentoComponent implements OnInit {
  abastecimento!: AbastecimentosViewModel;
  //contatos!: Contato[];
  contatoSelecionado!: string;
  observacao: string = '';
  numChamado: string = '';
  listaCombustiveis!: NomeCombustivel[];
  routeState: any;
  loading: boolean = false;
  usuario !: LoginModel | undefined;

  private urlAnterior: string = 'subfrota/relatorio-abastecimentos-editaveis'


  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private snackBar: SnackBarService,
    private fb: FormBuilder,
    private localStorageService: LocalStorageService,
    private subFrotaService: SubfrotaService,
  ) {

    if (this.router.getCurrentNavigation()?.extras.state) {
      this.routeState = this.router.getCurrentNavigation()?.extras.state;
      if (this.routeState) {
        this.abastecimento = this.routeState.abst;
        this.listaCombustiveis = this.routeState.combustiveis;
        // this.buscarContatos();
      }
    } else {
      this.router.navigateByUrl(this.urlAnterior);
    }
  }

  ngOnInit(): void {

    this.loading = true;
    this.usuario = this.subFrotaService?.usuario;
    // Verifica se o guid do usuário é ou continua válido.
    this.authenticationService.validate(this.subFrotaService?.usuario?.retorno?.guid ?? '')
      .then((dados => {
        if (!dados.sucesso) {
          this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
          this.usuario = undefined;
          // Redirecionar se nao logado
          this.router.navigateByUrl(this.urlAnterior);
        }
      }))
      .catch(() => {
        this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
      })
      .finally(() => {
        this.loading = false;
      });
  }

/*
  private async buscarContatos() {
    this.subFrotaService
      .getListaContatos(this.subFrotaService?.usuario?.retorno?.guid ?? '')
      //.getListaContatos('8335ee69-2da9-4402-bc0c-196f9ee5888d')
      .subscribe(ret => {

        this.contatos = ret.retorno;
        // this.contatoSelecionado = this.contatos[0].id;
      });
  }
*/
  public salvar(): void {
    this.enviarCorrecao()
  }

  public cancelar(): void {
    this.router.navigateByUrl(this.urlAnterior);
  }

  private enviarCorrecao(): void {
    this.loading = true;

    // enviar dados
    const editado: AbastecimentoPutModel = {
      guid: this.subFrotaService?.usuario?.retorno?.guid,
      codAbastecimento: this.abastecimento.codAbastecimento,
      vlrTotal: this.abastecimento.vlrTotal,
      indCombustivel: this.abastecimento.indCombustivel.trim(),
      qtdVolume: this.abastecimento.qtdVolume,
      dscObservacao: this.observacao.trim(),
      codPosto: this.abastecimento.codPosto,
      //numChamado: this.numChamado.trim(),
      numChamado: this.localStorageService.getItem('numeroChamadoAberto') === 'undefined' ? null : this.localStorageService.getItem('numeroChamadoAberto')

    };

    this.subFrotaService.salvarAbastecimentoEditado(editado).subscribe(result => {
      if (!result.sucesso) {
        const msgs = result.mensagens.join('\n');
        this.snackBar.flashMessage(msgs, ['snackbar-error'], 'Fechar', 0);
        this.loading = false;
        //this.router.navigateByUrl('/subfrota/editar-abastecimentos');
      } else {



        this.localStorageService.setItem("numeroChamadoAberto", result.retorno?.numeroChamado);
        this.loading = false;
        this.snackBar.flashMessage('Abastecimento editado enviado com sucesso!', ['snackbar-success'], 'Fechar', 0);

        this.router.navigateByUrl(this.urlAnterior);
      }

    })
  }

  exitemMudancas(): boolean {

    return this.observacao.length < 500 &&
      this.observacao.length > 0;
      // && this.contatoSelecionado != null;
    // this.numChamado?.length > 0;
  }

  setCombustivel(event: any) {
    this.abastecimento.indCombustivel = event.target.value;
  }

  onChangVlrTotal(vlrTotal: any) {
    var vc = vlrTotal.replace('R$', '').replace(',', '.');
    var valorNovo = parseFloat(vc.replace(/[^\d\.\-]/g, ""));
    this.abastecimento.vlrTotal = isNaN(valorNovo) ? this.abastecimento.vlrUnitario * this.abastecimento.qtdVolume : valorNovo;
  }


  escolherContato(event: any) {
    this.contatoSelecionado =  event.target.value;
  }
}
